{
  "COMMON": {
    "LOADING": "جارٍ التحميل...",
    "ERROR_CODE": {
      "ALXXX": "نأسف لعدم تمكننا من عرض خيارات الرحلات البديلة في الوقت الحالي. يُرجى تحديد خيار آخر أو المحاولة مرة أخرى لاحقًا. يمكنك أيضًا التواصل مع ممثلي خدمة العملاء عبر <a href='{{link}}' target='_blank'>هذا النموذج.</a> [Error code {{errorCode}}]",
      "COXXX_1": "نأسف لعدم تمكننا من المتابعة في عملية حجزك في الوقت الحالي. يُرجى المحاولة مرة أخرى لاحقًا. [Error code {{errorCode}}]",
      "COXXX_2": "نأسف لعدم تمكننا من تحديد حجزك في الوقت الحالي. يُرجى المحاولة مرة أخرى لاحقًا أو التواصل مع ممثلي خدمة العملاء عبر <a href='{{link}}' target='_blank'>هذ النموذج.</a> [Error code {{errorCode}}]",
      "DIXXX": "نأسف لعدم تمكننا من المتابعة إلى طلبك في الوقت الحالي. يُرجى المحاولة مرة أخرى لاحقًا أو التواصل مع ممثلي خدمة العملاء عبر <a href='{{link}}' target='_blank'>هذ النموذج.</a> [Error code {{errorCode}}]",
      "EMXXX": "عذرًا، لم نتمكن من إرسال البريد الإلكتروني. يُرجى المحاولة مرة أخرى لاحقًا. [Error code {{errorCode}}]",
      "EXXXX": "نأسف لعدم تمكننا من المتابعة إلى طلبك في الوقت الحالي. يُرجى المحاولة مرة أخرى لاحقًا أو التواصل مع ممثلي خدمة العملاء عبر <a href='{{link}}' target='_blank'>هذ النموذج.</a> [Error code {{errorCode}}]",
      "EX115": "نأسف لعدم تمكننا من المتابعة إلى طلبك في الوقت الحالي. يُرجى المحاولة مرة أخرى بعد 15 دقيقة أو التواصل مع خدمة دعم العملاء عبر <a href='{{link}}' target='_blank'>هذا النموذج.</a> [Error code {{errorCode}}]",
      "EX197": "عذرًا، واجهنا مشكلة أثناء العمل على رد المبلغ المدفوع. يُرجى المحاولة مرة أخرى أو التواصل مع خدمة دعم العملاء عبر <a href='{{link}}' target='_blank'>هذا النموذج.</a>",
      "EX503": "نواجه تعطلًا في الخدمة، ولكن سيتم حله قريبًا. يُرجى المحاولة مرة أخرى بعد بضع دقائق أو التواصل مع خدمة دعم العملاء عبر <a href='{{link}}' target='_blank'>هذا النموذج.</a>",
      "EX401": "انتهت صلاحية جلستك. يُرجى تحديث الصفحة والمحاولة مرة أخرى. إذا استمرت المشكلة، يُرجى التواصل مع خدمة دعم العملاء عبر <a href='{{link}}' target='_blank'>هذا النموذج.</a>",
      "OFXXX": "نأسف لعدم تمكننا من المتابعة في عملية حجزك في الوقت الحالي. يُرجى المحاولة مرة أخرى لاحقًا. [Error code {{errorCode}}]",
      "SEXXX": "نأسف لعدم تمكننا من المتابعة في عملية حجزك في الوقت الحالي. يُرجى المحاولة مرة أخرى لاحقًا. [Error code {{errorCode}}]",
      "SGXXX": "نأسف لعدم تمكننا من المتابعة إلى طلبك في الوقت الحالي. يُرجى المحاولة مرة أخرى لاحقًا أو التواصل مع ممثلي خدمة العملاء عبر <a href='{{link}}' target='_blank'>هذ النموذج.</a> [Error code {{errorCode}}]",
      "SHXXX": "نأسف لعدم تمكننا من عرض خيارات الرحلات البديلة في الوقت الحالي. يُرجى تحديد خيار آخر أو المحاولة مرة أخرى لاحقًا. يمكنك أيضًا التواصل مع ممثلي خدمة العملاء عبر <a href='{{link}}' target='_blank'>هذا النموذج.</a> [Error code {{errorCode}}]",
      "RFXXX": "نأسف لعدم تمكننا من المتابعة إلى طلبك في الوقت الحالي. يُرجى المحاولة مرة أخرى لاحقًا أو التواصل مع ممثلي خدمة العملاء عبر <a href='{{link}}' target='_blank'>هذ النموذج.</a> [Error code {{errorCode}}]",
      "REBOOKING_TIMED_OUT": "انتهت مهلة طلب إعادة الحجز، ولكن ما تزال عملية إعادة الحجز قيد المعالجة من جانبنا. يُرجى المحاولة مرة أخرى لاحقًا أو التواصل مع ممثلي خدمة العملاء عبر <a href='{{link}}' target='_blank'>هذ النموذج،</a> إذا لم تتلق أي رسالة تأكيد عبر البريد الإلكتروني في غضون دقائق قليلة."
    },
    "SPREEDLY_ERROR_CODE": {
      "ACCOUNT_INACTIVE": "تعذر معالجة دفعتك. يُرجى التأكد من استخدام بطاقة اختبار صالحة أو التواصل مع فريق الدعم للحصول على المساعدة عبر <a href='{{link}}' target='_blank'>هذا النموذج</a>.",
      "BLANK": "تعذّر العثور على الحقل المطلوب. يُرجى ملء جميع تفاصيل الدفع المطلوبة والمحاولة مرة أخرى.",
      "INVALID": "معلومات الدفع التي أدخلتَها غير صالحة. يُرجى التحقق من الحقول المحددة والمحاولة مرة أخرى.",
      "BLANK_CARD_TYPE": "رقم بطاقة الائتمان الذي أدخلته غير صالح. يُرجى التحقق من رقم البطاقة والمحاولة مرة أخرى.",
      "EXPIRED": "طريقة الدفع التي أدخلتها مُنتهية الصلاحية. يُرجى استخدام طريقة دفع صالحة والمحاولة مرة أخرى.",
      "UNKNOWN_REFERRER": "لم نتمكن من التحقق من مصدر طلب الدفع الذي أجريتَه. يُرجى المحاولة مرة أخرى أو التواصل مع فريق الدعم للحصول على المساعدة عبر <a href='{{link}}' target='_blank'>هذا النموذج</a>.",
      "INVALID_REFERRER": "تعذر معالجة طلب الدفع بسبب مشكلة أمنية. يُرجى المحاولة مرة أخرى أو التواصل مع فريق الدعم للحصول على المساعدة عبر <a href='{{link}}' target='_blank'>هذا النموذج</a>.",
      "INVALID_ENVIRONMENT_KEY_PARAMETER": "حدث خطأ غير متوقع. يُرجى المحاولة مرة أخرى أو التواصل مع فريق الدعم للحصول على المساعدة عبر <a href='{{link}}' target='_blank'>هذا النموذج.</a>."
    },
    "BUTTON": {
      "CONTINUE": "متابعة",
      "BACK": "رجوع",
      "CLOSE": "إغلاق"
    },
    "PRODUCT_NAME": "المساعدة في اضطرابات السفر",
    "PRODUCT_NAME_FLYADEAL": "خدمة المساعدة المتميزة",
    "FLIGHT_INFORMATIONS": {
      "LAYOVER": "{{time}} توقف مؤقت في مطار {{airportName}} ({{airportCode}})",
      "BOOKING_REFERENCE": "مرجع الحجز: {{pnrReference}}",
      "STATUS": {
        "CANCELLED": "مُلغاة",
        "DELAYED": "متأخرة",
        "FLOWN": "أقلعت الرحلة",
        "BOARDED": "تم صعود الركاب",
        "CONFIRMED": "مؤكّدَة"
      },
      "CABIN": {
        "ECONOMY": "الدرجة الاقتصادية",
        "PREMIUM_ECONOMY": "درجة اقتصادية مميزة",
        "BUSINESS": "درجة رجال الأعمال",
        "FIRST": "الدرجة الأولى"
      },
      "NO_STOP": "رحلة مباشرة",
      "STOP": {
        "ZERO": "محطتي توقف {{count}} في {{destinations}}",
        "ONE": "محطة توقف {{count}} في {{destinations}}",
        "TWO": "محطتي توقف {{count}} في {{destinations}}",
        "FEW": "محطتي توقف {{count}} في {{destinations}}",
        "MANY": "{{count}} محطة توقف في {{destinations}}",
        "OTHER": "{{count}} محطة توقف في {{destinations}}"
      },
      "FLIGHT": "الرحلة",
      "OUTBOUND_FLIGHT": "رحلة ذهاب",
      "INBOUND_FLIGHT": "رحلة عودة",
      "REBOOKED_BY_AIRLINE": "تمت إعادة الحجز بواسطة {{partnerName}}",
      "PASSENGER_TYPE": {
        "ADULT": {
          "ZERO": "شخصان {{count}} بالغان",
          "ONE": "شخص {{count}} بالغ",
          "TWO": "شخصان {{count}} بالغان",
          "FEW": "{{count}} أشخاص بالغين",
          "MANY": "{{count}} شخصًا بالغًا",
          "OTHER": "{{count}} شخصًا بالغًا"
        },
        "CHILD": {
          "ZERO": "طفلان {{count}}",
          "ONE": "{{count}} طفل",
          "TWO": "طفلان {{count}}",
          "FEW": "{{count}} أطفال",
          "MANY": "{{count}} طفلًا",
          "OTHER": "{{count}} طفلًا"
        },
        "SEATED_INFANT": {
          "ZERO": "طفلان رضيعان {{count}} (مع مقعد)",
          "ONE": "طفل رضيع {{count}} (مع مقعد)",
          "TWO": "طفلان رضيعان {{count}} (مع مقعد)",
          "FEW": "{{count}} أطفال رضّع (مع مقعد)",
          "MANY": "{{count}} طفلًا رضيعًا (مع مقعد)",
          "OTHER": "{{count}} طفلًا رضيعًا (مع مقعد)"
        },
        "LAP_INFANT": {
          "ZERO": "{{count}} طفلان رضيعان (من دون مقعد)",
          "ONE": "طفل رضيع {{count}} (من دون مقعد)",
          "TWO": "{{count}} طفلان رضيعان (من دون مقعد)",
          "FEW": "{{count}} أطفال رضّع (من دون مقعد)",
          "MANY": "{{count}} طفلًا رضيعًا (من دون مقعد)",
          "OTHER": "{{count}} طفل رضيع (من دون مقعد)"
        }
      }
    },
    "REFUND": {
      "DEFAULT_HEADER": {
        "TITLE": "استرداد المبلغ المدفوع",
        "SUBTITLE": "ستحصل على <b>{{amount}}</b> نقدًا، ما يعادل 100% من مبلغ حجزك المشمول بالتغطية. لن نجري أي تغييرات على حجزك مع {{partnerName}}، لذلك ستحتفظ أيضًا برحلتك الحالية.<br /><br /> دعنا نتأكد من معلوماتك حتى نتمكن من معالجة استرداد المبلغ المدفوع!"
      },
      "CONFIRMATION_HEADER": {
        "TITLE": "تمت العملية بنجاح. جارٍ معالجة استرداد المبلغ المدفوع <b>{{amount}}</b>.",
        "SUBTITLE": "سيتم إرسال رسالة تأكيد بالبريد الإلكتروني قريبًا إلى <b>{{email}}</b>. ما يزال حجز رحلتك الأصلي ساريًا. شكرًا لك على استخدام خدمة {{productName}}!"
      },
      "FORM_HEADER": {
        "PERSONAL_INFORMATION": "المعلومات الشخصية",
        "HOME_ADDRESS_INFORMATION": "عنوان المنزل"
      },
      "FORM": {
        "FIRST_NAME": "الاسم الأول",
        "LAST_NAME": "اسم العائلة",
        "ADDRESS_LINE_1": "السطر الأول للعنوان",
        "ADDRESS_LINE_2": "السطر الثاني للعنوان (اختياري)",
        "CITY": "المدينة",
        "COUNTRY": "البلد",
        "STATE": "الولاية/المقاطعة",
        "ZIP": "الرمز البريدي"
      }
    },
    "GENDER": {
      "MALE": "ذكر",
      "FEMALE": "أنثى",
      "UNDISCLOSED": "غير معلن",
      "UNSPECIFIED": "غير محدد"
    }
  },
  "HOME": {
    "CONTRACT_ALREADY_REFUNDED": "تم استلام طلب الإلغاء الخاص بك بالفعل، وجارٍ معالجة استرداد المبلغ. إذا كنت بحاجة إلى المساعدة، يمكنك التواصل مع فريق دعم العملاء عبر <a href='{{link}}' target='_blank'>هذا النموذج.</a>",
    "NO_DISRUPTION": "تعذَّر العثور على رحلة متأخرة أو ملغاة."
  },
  "NOT_FOUND": {
    "TITLE": "الصفحة غير موجودة",
    "MESSAGE": "نأسف. تعذر العثور على الصفحة التي تبحث عنها.",
    "GO_HOME": "انتقل إلى الصفحة الرئيسية"
  },
  "SERVICE_DISRUPTION_STEP": {
    "TITLE": "الخدمة غير متوفرة مؤقتًا",
    "MESSAGE": "نواجه تعطلًا في الخدمة، ولكن سيتم حله قريبًا.",
    "TRY_AGAIN": "يُرجى المحاولة مرة أخرى بعد بضع دقائق.",
    "CONTACT_CUSTOMER_SUPPORT": "الاتصال بخدمة دعم العملاء"
  },
  "FLIGHT_INFORMATIONS": {
    "NOT_ELIGIBLE": "نحن نتابع رحلتك. عد إلى هنا إذا واجهت تأخيرًا يزيد عن {{minMinutesDelay}} دقيقة أو إلغاء في غضون {{maxHoursBeforeDeparture}} ساعات من موعد مغادرة الرحلة.",
    "CHOICE_SELECTION": "ما الذي تود فعله؟",
    "REBOOK": {
      "TITLE": "إعادة حجز رحلة جديدة",
      "DESC": "يمكنك اختيار إعادة حجز رحلة جديدة على أي شركة طيران، والاختيار بين الرحلات المغادرة اليوم أو غدًا."
    },
    "REFUND": {
      "TITLE": "استرداد المبلغ المدفوع والإبقاء على الرحلة",
      "DESC": "إذا لم تكن راضيًا عن خيارات إعادة الحجز، يُمكنك استرداد المبلغ <b>{{amount}}</b> والاحتفاظ برحلتك التي تعطلت."
    }
  },
  "PRODUCT_INFORMATIONS": {
    "PRODUCT_INFO": "نظرًا لأنك دفعت مقابل خدمة {{productName}}، يحق لك إعادة الحجز أو استرداد المبلغ المدفوع، إذا لم تكن راضيًا عن خيارات إعادة الحجز أو إذا تم إلغاء رحلتك أو تأخيرها لأكثر من {{minMinutesDelay}} دقائق، في غضون {{maxHoursBeforeDeparture}} ساعات من موعد مغادرة الرحلة.",
    "PRODUCT_INFO_HOURS": "لأنك اشتريت {{productName}}، يحق لك الحصول على إعادة حجز، أو استرداد للمبلغ إذا لم تكن راضيًا عن خياراتنا لإعادة الحجز، وذلك في حال تم إلغاء رحلتك أو تأخيرها لأكثر من {{minMinutesDelay}} من الساعات في غضون {{maxHoursBeforeDeparture}} من الساعات من موعد المغادرة."
  },
  "SLICE_DETAILS_DIALOG": {
    "TITLE": "رحلة ذهاب إلى {{destination}}"
  },
  "SLICE_INFORMATIONS": {
    "ELIGIBLE_FOR_REBOOKING": "مؤهل لإعادة الحجز",
    "NOT_ELIGIBLE_FOR_REBOOKING": "غير مؤهل لإعادة الحجز"
  },
  "SEND_VERIFICATION_CODE_STEP": {
    "SEND_VERIFICATION_TITLE": "لنتأكد من هويتك!",
    "SEND_VERIFICATION_TEXT": "سنرسل رمزًا إلى البريد الإلكتروني الذي استخدمته عند حجز رحلتك.",
    "BUTTON": {
      "SEND_VERIFICATION_CODE": "إرسال الرمز"
    }
  },
  "CHECK_VERIFICATION_CODE_STEP": {
    "CHECK_VERIFICATION_TITLE": "لنتأكد من هويتك!",
    "CHECK_VERIFICATION_TEXT": "لقد أرسلنا للتو رسالة بريد إلكتروني تحتوي على رمز تحقق إلى {{email}}.",
    "BUTTON": {
      "RESEND_VERIFICATION_CODE": "إرسال رمز جديد"
    }
  },
  "HYPERWALLET_FORM_STEP": {
    "FORM": {
      "MIDDLE_NAME": "الاسم الأوسط (اختياري)",
      "DATE_OF_BIRTH": "تاريخ الميلاد"
    }
  },
  "HYPERWALLET_REFUND_STEP": {
    "RECEIVE_AMOUNT_TITLE": "كيف ترغب في استرداد المبلغ المدفوع؟"
  },
  "SPREEDLY_FORM_STEP": {
    "CARD_INFORMATION": "معلومات البطاقة",
    "FORM": {
      "FULL_NAME": "الاسم الكامل",
      "CARD_NUMBER": "رقم البطاقة",
      "EXPIRATION_MONTH": "شهر انتهاء الصلاحية",
      "EXPIRATION_YEAR": "سنة انتهاء الصلاحية",
      "CVV": "رمز التحقق من البطاقة"
    },
    "BUTTON": {
      "REDIRECT_TO_BANK_TRANSFER": "ليس لدي بطاقة ائتمان"
    }
  },
  "BANK_TRANSFER_FORM_STEP": {
    "DESC": "سنرسل استرداد المبلغ المدفوع إلى حسابك البنكي.",
    "FORM": {
      "BANK_INFORMATION": "معلومات الحساب المصرفي",
      "ACCOUNT_NUMBER": "رقم الحساب المصرفي الدولي (IBAN)/رقم الحساب المصرفي",
      "BANK_ID": "رمز السويفت/رمز البنك الدولي (BIC)",
      "ACCOUNT_HOLDER_INFORMATION": "معلومات صاحب الحساب",
      "VALIDATION": {
        "REQUIRED": "هذا الحقل مطلوب",
        "INVALID_IBAN": "يرجى إدخال رقم آيبان (IBAN) صالح",
        "INVALID_BIC": "يُرجى إدخال رمز سويفت/رمز تعريف بنك (BIC) صالح",
        "formValidationAccountNumberRequired": "يُرجى إدخال رقم حسابك البنكي.",
        "formValidationBankCodeRequired": "يُرجى إدخال رمز البنك.",
        "formValidationBankCodeLength": "يجب أن يتكوّن رمز البنك من 8 إلى 11 حرفًا.",
        "formValidationBankCodeFirstChars": "يجب أن يبدأ رمز البنك بأربعة أحرف.",
        "formValidationBankCodeCountryUnsupported": "رمز بلد البنك هذا غير مدعوم للتحويلات الدولية.",
        "formValidationBankCodeCountryInvalid": "رمز البلد في رمز البنك غير صالح.",
        "formValidationBankCodeLocationInvalid": "رمز الموقع في رمز البنك غير صالح.",
        "formValidationBankCodeBranchInvalid": "رمز الفرع في رمز البنك غير صالح.",
        "formValidationIbanCharsInvalid": "يحتوي رقم حسابك البنكي على أحرف غير صالحة. يُرجى استخدام الأحرف والأرقام فقط.",
        "formValidationIbanCountryInvalid": "يجب أن يبدأ رقم حسابك البنكي برمز بلد صالح.",
        "formValidationIbanCountryUnsupported": "بلد رقم الحساب البنكي هذا غير مدعوم للتحويلات الدولية.",
        "formValidationIbanLengthInvalid": "يحتوي رقم حسابك البنكي على طول غير صالح لهذا البلد.",
        "formValidationIbanChecksumInvalid": "رقم حسابك البنكي غير صالح. يُرجى التحقّق والمحاولة مرة أخرى.",
        "formValidationIbanBicCountryMismatch": "لا يتطابق البلد في رقم حسابك البنكي مع البلد في رمز البنك."
      }
    }
  },
  "PAYOUT_ERROR_STEP": {
    "TITLE": "تعذّر علينا إنهاء طلبك بخصوص {{productName}}",
    "SUBTITLE": "نعتذر عن الإزعاج، واجهنا مشكلة أثناء العمل على رد المبلغ المدفوع. يُرجى النقر على <b>متابعة</b> لمراجعة خياراتنا لمعالجة استرداد المبلغ المدفوع. إذا واجهت أي صعوبة، يُرجى التواصل مع خدمة دعم العملاء عبر <a href='{{link}}' target='_blank'>هذا النموذج.</a>",
    "NO_PAYOUT_OPTIONS": "يُرجى التواصل مع خدمة دعم العملاء عبر <a href='{{link}}' target='_blank'>هذا النموذج.</a>"
  },
  "REBOOKING_CONFIRMATION_STEP": {
    "TITLE": "اجلس واسترخ! تم تأكيد حجزك الجديد.",
    "SUBTITLE": "سيتم إرسال رسالة تأكيد بالبريد الإلكتروني قريبًا إلى {{email}}. شكرًا لك على استخدام خدمة {{productName}}!",
    "YOUR_NEW_FLIGHT": "رحلتك الجديدة",
    "ROUND_TRIP_WARNING": "ننصح بشدة التأكيد مباشرة مع شركة Frontier Airlines على أنه لن يتم إلغاء أي رحلات متبقية في حجزك، بما في ذلك أي رحلات ذهاب وعودة، إذا رفضت أو تخطيت خيارات إعادة الحجز التي تقدمها شركة Frontier Airlines."
  },
  "REBOOKING_FORM_STEP": {
    "TITLE": "معلومات الراكب",
    "SUBTITLE": "دعنا نتأكد من معلوماتك قبل إعادة حجز رحلتك.",
    "LOADING_REBOOK": "جارٍ إعادة الحجز...",
    "PASSENGER": "راكب {{index}}",
    "BUTTON": {
      "SUBMIT": "تأكيد وإعادة الحجز"
    },
    "TRAVEL_DOCUMENT": "وثيقة السفر",
    "FORM": {
      "FIRST_NAME": "الاسم الأول",
      "LAST_NAME": "اسم العائلة",
      "GENDER": "الجنس",
      "DOCUMENT_TYPE": "نوع الوثيقة",
      "PASSPORT_NUMBER": "رقم جواز السفر",
      "COUNTRY_ISSUANCE": "بلد الإصدار",
      "NATIONALITY": "الجنسية",
      "ISSUANCE_DATE": "تاريخ الإصدار",
      "EXPIRATION_DATE": "تاريخ انتهاء الصلاحية",
      "DATE_OF_BIRTH": "تاريخ الميلاد",
      "NATIONAL_ID_NUMBER": "رقم الهوية الوطنية"
    },
    "DOCUMENT_TYPES": {
      "passport": "جواز السفر",
      "national_id": "الهوية الوطنية"
    }
  },
  "REBOOKING_REVIEW_STEP": {
    "TITLE": "إعادة حجز رحلتك",
    "SUBTITLE": "يمكنك اختيار إعادة حجز رحلة جديد مجانًا (بقيمة {{serviceCap}} لكل راكب)، والاختيار من بين رحلات اليوم نفسه أو اليوم التالي. إذا اخترت رحلة جديدة، سيتم إلغاء رحلتك الأولى مع {{partnerName}}، لكنك ستحتفظ برحلات العودة، إن أمكن.",
    "LOADING_REBOOK": "جارٍ إعادة الحجز...",
    "CHOICE_SUMMARY": "فيما يلي ملخص اختياراتك",
    "DIFFERENT_AIRPORT": "يرجى التحقق من خط سير رحلتك، لقد اخترت خط سير رحلة تغادر من أو تصل إلى مطار مختلف مقارنةً برحلتك الأولى."
  },
  "REBOOKING_SEARCH_ALTERNATIVES_STEP": {
    "TITLE": "إعادة حجز رحلتك",
    "SUBTITLE": "يمكنك اختيار إعادة حجز رحلة جديد مجانًا (بقيمة {{serviceCap}} لكل راكب)، والاختيار من بين رحلات اليوم نفسه أو اليوم التالي. إذا اخترت رحلة جديدة، سيتم إلغاء رحلتك الأولى مع {{partnerName}}، لكنك ستحتفظ برحلات العودة، إن أمكن.",
    "LOADING_REBOOK": "جارٍ إعادة الحجز...",
    "LOADING_ALTERNATIVES": "يرجى الانتظار أثناء تحميل خيارات إعادة الحجز",
    "ONE_MORE_ALTERNATIVE": "{{nbAlternative}} المزيد من الخيارات",
    "MORE_ALTERNATIVES": "{{nbAlternative}} المزيد من الخيارات",
    "NO_ALTERNATIVE": "نأسف، لا توجد رحلات متاحة ليوم المغادرة هذا حاليًا. يمكنك الاختيار من بين أحد الخيارات التالية: ",
    "BAGS_TITLE": "هل لديك حقائب مسجلة على الرحلة؟",
    "BUTTON": {
      "YES": "نعم",
      "NO": "لا",
      "GO_TO_REFUND_FLOW": "تحديد خيار استرداد المبلغ المدفوع",
      "SEARCH_FOR_OTHER_DAY": "البحث عن الرحلات المتاحة قبل يوم واحد أو بعد يوم واحد"
    },
    "OUTBOUND": "رحلة ذهاب إلى {{destination}}",
    "NO_STOP": "رحلة مباشرة",
    "STOP": {
      "ZERO": "{{count}} محطتي توقف",
      "ONE": "{{count}} محطة توقف",
      "TWO": "{{count}} محطتي توقف",
      "FEW": "{{count}} محطات توقف",
      "MANY": "{{count}} محطة توقف",
      "OTHER": "{{count}} محطة توقف"
    },
    "SEE_OTHER_AIRLINES": "عرض خطوط جوية إضافية"
  },
  "WARNING_BAGS_DIALOG": {
    "TITLE": "ملاحظة مهمة بشأن الحقائب المسجلة",
    "DESC": "نظرًا لأنك سجلت بعض الحقائب في رحلتك التي تعطلت مع شركة الطيران، يجب تفريغها وإعادة تسجيلها في رحلتك الجديدة. للقيام بذلك، يرجى زيارة مكتب تسجيل الوصول التابع لشركة الطيران في المطار.<br /><br />لا يمكننا ضمان تفريغ حقائبك في الوقت المناسب لتسجيلها في رحلتك الجديدة.",
    "DESC_FLYADEAL": "نظرًا لأنك سجَّلت بعض الحقائب في رحلتك الجوية التي تعطّلت لدى شركة الطيران، يجب إنزالها وإعادة تسجيلها في رحلتك الجوية الجديدة. للقيام بذلك، يرجى زيارة خدمة عملاء شركة الطيران أو خدمة استلام الأمتعة في المطار للحصول على أمتعتك.<br /><br />تقع على عاتقك مسؤولية استلام حقائبك وتسجيلها في الرحلة الجوية الجديدة في الوقت المناسب.",
    "BUTTON": {
      "REFUND": "الإبقاء على الرحلة واسترداد المبلغ المدفوع",
      "REBOOK": "إعادة حجز وإدارة حقائبي"
    }
  },
  "ALTERNATIVE_DETAILS_DIALOG": {
    "TITLE": "رحلة ذهاب إلى {{destination}}",
    "BUTTON": {
      "SUBMIT": "اختر هذه الرحلة"
    }
  }
}
